export enum LeadAutomationNotifyUserType {
Owner,
SpecificAccounts,
}
